import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <Logo className="w-10 h-10 text-[#C5A059]" />
            <div className="font-serif text-2xl text-white">Da Pra Assicurazioni</div>
          </div>
          <div className="overline mt-3" style={{ color: "#C5A059" }}>Plurimandataria · Milano · Dal 1958</div>
          <p className="mt-6 text-sm text-slate-400 max-w-md leading-relaxed">
            Agenzia <strong className="text-slate-200">plurimandataria</strong>: confrontiamo le soluzioni delle migliori compagnie
            e costruiamo polizze cucite sulle reali esigenze del cliente.
            Auto, casa, ramo vita e coperture dedicate.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="overline" style={{ color: "#C5A059" }}>Polizze</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/assicurazione-auto-milano" className="hover:text-white" data-testid="footer-link-auto">Assicurazione Auto</Link></li>
            <li><Link to="/assicurazione-casa" className="hover:text-white" data-testid="footer-link-casa">Assicurazione Casa</Link></li>
            <li><Link to="/polizza-vita" className="hover:text-white" data-testid="footer-link-vita">Polizza Vita</Link></li>
            <li><Link to="/infortuni-malattia" className="hover:text-white" data-testid="footer-link-infortuni">Infortuni e Malattia</Link></li>
            <li><Link to="/rc-professionale" className="hover:text-white" data-testid="footer-link-rc-pro">RC Professionale</Link></li>
            <li><Link to="/assicurazione-monopattino" className="hover:text-white" data-testid="footer-link-monopattino">Monopattino Elettrico</Link></li>
            <li><Link to="/assicurazione-cani-gatti" className="hover:text-white" data-testid="footer-link-cani-gatti">Cani e Gatti</Link></li>
            <li><Link to="/preventivo" className="hover:text-white" data-testid="footer-link-preventivo">Richiedi preventivo</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline" style={{ color: "#C5A059" }}>Contatti</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 text-[#C5A059]" />
              <a href="mailto:info@dapraassicurazioni.it" className="hover:text-white" data-testid="footer-email">
                info@dapraassicurazioni.it
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 text-[#C5A059]" />
              <a href="mailto:dapraassicurazioni@propec.it" className="hover:text-white" data-testid="footer-pec">
                <span className="block text-[10px] tracking-wider uppercase text-slate-500">PEC</span>
                dapraassicurazioni@propec.it
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-[#C5A059]" />
              <a href="tel:+390220177" className="hover:text-white">+39 02 20 17 77</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-[#C5A059]" />
              <span>Via Lambro, 4 — 20129 Milano</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline" style={{ color: "#C5A059" }}>Orari</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-400">
            <li>Lun – Gio · 9:00 – 13:00 · 14:00 – 18:00</li>
            <li>Venerdì · 9:00 – 13:00 · 14:00 – 18:00 <span className="text-slate-500">(smart working)</span></li>
            <li>Sabato · 9:00 – 13:00 <span className="text-slate-500">(smart working)</span></li>
            <li>Domenica · chiuso</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-8 grid md:grid-cols-3 gap-6 text-xs text-slate-500">
          <div>
            <div className="overline" style={{ color: "#C5A059" }}>Dati societari</div>
            <ul className="mt-3 space-y-1.5 leading-relaxed">
              <li>Da Pra Assicurazioni</li>
              <li>Via Lambro, 4 — 20129 Milano</li>
              <li>P.IVA: <span className="text-slate-300">01798590988</span></li>
              <li>PEC: <a href="mailto:dapraassicurazioni@propec.it" className="text-slate-300 hover:text-white">dapraassicurazioni@propec.it</a></li>
            </ul>
          </div>
          <div>
            <div className="overline" style={{ color: "#C5A059" }}>Iscrizione RUI</div>
            <p className="mt-3 leading-relaxed">
              Iscrizione al Registro Unico degli Intermediari assicurativi e
              riassicurativi n. <span className="text-slate-300">A000008224</span>,
              data iscrizione 01 Febbraio 2007. L'intermediario è soggetto al
              controllo dell'IVASS, così come indicato nell'art. 61 del
              Regolamento Isvap n. 5/06.{" "}
              <a
                href="https://www.ivass.it/operatori/intermediari/rui/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 underline underline-offset-2 hover:text-white"
                data-testid="ivass-rui-link"
              >
                Consultabile sul sito dell'IVASS
              </a>.
            </p>
          </div>
          <div>
            <div className="overline" style={{ color: "#C5A059" }}>Responsabile attività di intermediazione</div>
            <p className="mt-3 leading-relaxed">
              <span className="text-slate-300">Da Pra Michele</span><br />
              Numero iscrizione RUI: <span className="text-slate-300">A000008224</span>
            </p>
          </div>
        </div>
        <div className="border-t border-slate-800">
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 text-xs text-slate-500 flex flex-col md:flex-row justify-between gap-3">
            <span>© {new Date().getFullYear()} Da Pra Assicurazioni · Agenzia plurimandataria · Tutti i diritti riservati.</span>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
              <a
                href="https://www.iubenda.com/privacy-policy/72154629"
                className="iubenda-white iubenda-noiframe iubenda-embed hover:text-slate-300"
                title="Privacy Policy"
                data-testid="iubenda-privacy"
              >
                Privacy Policy
              </a>
              <a
                href="https://www.iubenda.com/privacy-policy/72154629/cookie-policy"
                className="iubenda-white iubenda-noiframe iubenda-embed hover:text-slate-300"
                title="Cookie Policy"
                data-testid="iubenda-cookie"
              >
                Cookie Policy
              </a>
              <a href="/admin/login" className="hover:text-slate-300" data-testid="footer-admin-link">
                Area riservata
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
